import {
  Box,
  Grid,
  Button,
  CircularProgress,
  Backdrop,
  IconButton,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CollapseSection from "../../../components/ui/CollapseSection";
import {
  getUserCountries,
  GetDatasources,
  GetDatasourcesByCountry,
  GetInDemandDataReport,
  ExportInDemandReport,
  setState,
} from "../analyzeSlice";
import { DataGrid } from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Alert from "../../../components/ui/Alert";
import moment from "moment";

const localColumns = [
  { field: "dataSource", headerName: "DataSource", flex: 1 },
  {
    field: "geoName",
    headerName: "Geo Name",
    flex: 1,
  },
  {
    field: "customerName",
    headerName: "Customer Name",
    flex: 1,
  },
  {
    field: "customerNumber",
    headerName: "Customer Number",
    flex: 1,
  },
  {
    field: "productName",
    headerName: "Product Name",
    flex: 1,
  },
  {
    field: "packName",
    headerName: "Pack Name",
    flex: 1,
  },
  {
    field: "company",
    headerName: "Company",
    flex: 1,
  },

  {
    field: "measure",
    headerName: "Measure",
    flex: 1.5,
  },

  {
    field: "skuNumber",
    headerName: "SKU Number",
    flex: 1.5,
  },

  {
    field: "skuName",
    headerName: "SKU Name",
    flex: 1,
  },
  {
    field: "source",
    headerName: "Source",
    flex: 1,
  },
  {
    field: "period",
    headerName: "Period",
    flex: 1,
    valueFormatter: (params) => moment(params.value).format('DD/MM/YYYY')
  },
  {
    field: "value",
    headerName: "Value",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString('en-US');
      return formattedValue;
    },
  },
];

const mdrColumns = [
  { field: "dataSource", headerName: "DataSource", flex: 1 },
  {
    field: "geoName",
    headerName: "Geo Name",
    flex: 1,
  },
  {
    field: "product",
    headerName: "Product",
    flex: 1,
  },
  {
    field: "strength",
    headerName: "Strength",
    flex: 1,
  },
  {
    field: "skuName",
    headerName: "SKU Name",
    flex: 2,
  },
  {
    field: "channel",
    headerName: "Channel",
    flex: 1,
  },
  {
    field: "unitofMeasure",
    headerName: "Unit of Measure",
    flex: 1,
  },
  {
    field: "period",
    headerName: "Period",
    flex: 1,
    valueFormatter: (params) => moment(params.value).format('DD/MM/YYYY')
  },
  {
    field: "units",
    headerName: "Units",
    flex: 1,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString('en-US');
      return formattedValue;
    },
  },

  {
    field: "weightInMCGorMG",
    headerName: "Weight in MCG or MG",
    flex: 1.5,
    valueFormatter: (params) => {
      const formattedValue = params.value?.toLocaleString('en-US');
      return formattedValue;
    },
  },
];

const duration = [
  { durationID: 1, durationName: "Last 1 Months" },
  { durationID: 6, durationName: "Last 6 Months" },
  { durationID: 12, durationName: "Last 12 Months" },
  { durationID: 24, durationName: "Last 24 Months" },
  { durationID: 36, durationName: "Last 36 Months" },
];

export default function InDemandDataReport() {
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const loginState = useSelector((store) => store.login);
  const {
    isLoading,
    countries,
    selectedCountry,
    selectedCountryID,
    dataSourceByCountry,
    getInDemandDataReport,
    selectedDataSource,
    selectedDataSourceID,
    selectedDurationID,
    selectedDurationName,
    showOrHideExport,
  } = state;

  const [datasource, setDataSource] = useState([]);
  const [columns, setColumns] = useState([]);
  const [validate, setValidate] = useState({
    countryValidated: false,
    datasourceValidated: false,
    datasourceIdValidated: false,
    durationValidated: false,
  });
  const { globalSelectedCountryName, globalSelectedCountryID } = loginState;
  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: "",
  });

  useEffect(() => {
    dispatch(setState("selectedDataSource", ""));
    dispatch(setState("selectedDataSourceID", ""));
    dispatch(setState("selectedDurationID", ""));
    dispatch(setState("selectedDurationName", ""));
    dispatch(setState("getInDemandDataReport", []));
  }, []);

  useEffect(() => {
    if (countries.length <= 0) {
      dispatch(getUserCountries({ method: "Get" }));
    }
  }, []);

  useEffect(() => {
    if (dataSourceByCountry.length > 0) {
      setDataSource(dataSourceByCountry);
      setValidate({
        ...validate,
        datasourceValidated: false,
        datasourceIdValidated: true,
      });
    } else {
      setValidate({
        ...validate,
        datasourceIdValidated: false,
      });
    }
  }, [dataSourceByCountry]);

  const displayAlert = (showAlert, alertMessage) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: `${showAlert}`,
      alertMessage: `${alertMessage}`,
    });
  };

  useEffect(() => {
    //Check if any of the dropdown are false and then set alertDisplay to false
    const isAnyKeyValueFalse = (o) => !!Object.keys(o).find((k) => !o[k]);

    if (isAnyKeyValueFalse(validate)) {
      setAlert({ ...Alert, alertDisplay: false });
    }
  }, [validate]);

  const handleCountryChange = (e) => {
    const name = e.target.value;
    let id = 0;
    // if (name !== "All") {
    //   id = countries.find((c) => c.countryName === name).countryID;
    //   dispatch(GetDatasourcesByCountry({ method: "Get", countryId: id }));
    // } else {
    //   dispatch(GetDatasources({ method: "Get" }));
    // }

    if (name !== "All") {
      id = countries.find((c) => c.countryName === name).countryID;
    }

    dispatch(GetDatasources({ method: "Get", countryId: id }));

    if (name) {
      setValidate({
        ...validate,
        countryValidated: true,
      });
    }

    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", id));
    dispatch(setState("selectedDataSource", ""));
    dispatch(setState("selectedDataSourceID", ""));

    dispatch(setState("getInDemandDataReport", []));
    setDataSource([]);
  };

  useEffect(() => {
    if (globalSelectedCountryID !== null) {
      dispatch(setState("selectedCountryID", globalSelectedCountryID));
      dispatch(setState("selectedCountry", globalSelectedCountryName));
      dispatch(setState("selectedDataSource", ""));
      dispatch(setState("selectedDataSourceID", ""));
      dispatch(setState("getInDemandDataReport", []));
      setDataSource([]);
      dispatch(GetDatasources({ method: "Get", countryId: globalSelectedCountryID }));
    }
  }, [globalSelectedCountryID]);

  const handleDataSourceChange = (e) => {
    const name = e.target.value;
    let id = datasource.find((c) => c.dataSourceName === name).dataSourceID;

    if (name) {
      setValidate({
        ...validate,
        datasourceValidated: true,
        datasourceIdValidated: true,
      });
    }

    dispatch(setState("selectedDataSource", name));
    dispatch(setState("selectedDataSourceID", id));
    dispatch(setState("getInDemandDataReport", []));

    if (name == "MDR") setColumns(mdrColumns);
    else setColumns(localColumns);
  };

  const handleDurationChange = (e) => {
    let name = e.target.value;
    let id = duration.find((c) => c.durationName === name).durationID;

    if (name) {
      setValidate({
        ...validate,
        durationValidated: true,
      });
    }
    dispatch(setState("selectedDurationName", name));
    dispatch(setState("selectedDurationID", id));
  };

  const handleDisplay = () => {
    //  /Admin/GetInDemandDataReport?countryName=All&dataSource=Local&period=24
    let obj = {
      countryId: selectedCountryID,
      dataSourceId: selectedDataSourceID,
      period: selectedDurationID,
    };

    if (!validate.countryValidated)
      displayAlert(true, "Please select a Country");
    else if (!validate.datasourceIdValidated)
      displayAlert(true, "No DataSource available for selected country");
    else if (!validate.datasourceValidated)
      displayAlert(true, "Please select a DataSource");
    else if (!validate.durationValidated)
      displayAlert(true, "Please select Duration");
    else {
      dispatch(GetInDemandDataReport(obj));
    }
  };

  async function exportDataAsFile(isPdf) {
    const obj = {
      isPdf,
      AnalyzeTitle: "InDemandDataReport",
      CountryID: selectedCountryID,
      CountryName: selectedCountry,
      DataSourceID: selectedDataSourceID,
      DataSourceName: selectedDataSource,
      Duration: selectedDurationID,
      listAnalyseData: null,
    };

    dispatch(ExportInDemandReport(obj));
  }

  return (
    <div>
      <CollapseSection title="In Demand Data Report">
        <Box mt={4}>
          <Box mt={2}>
            {alert.alertDisplay && (
              <Alert
                message={alert.alertMessage}
                severity={alert.alertSeverity}
              />
            )}
            <Grid
              container
              columns={12}
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              pb={1}
            >
              <Grid item xs={6} sm={3} md={3} lg={3}>
                <TextField
                  variant="outlined"
                  label="Country"
                  select={countries.length > 0 ? true : false}
                  value={
                    countries.length > 0 ? selectedCountry : ""
                  }
                  onChange={handleCountryChange}
                  fullWidth
                  size="small"
                >
                  <MenuItem key="0" value={"All"}>
                    {"All"}
                  </MenuItem>
                  {countries.length > 0
                    ? countries.map((country, index) => {
                        return (
                          <MenuItem
                            key={country.countryID}
                            value={country.countryName}
                          >
                            {country.countryName}
                          </MenuItem>
                        );
                      })
                    : null}
                </TextField>
              </Grid>

              <Grid item xs={6} sm={3} md={3.6} lg={3.7}>
                <TextField
                  variant="outlined"
                  label="Data Source"
                  select={datasource.length > 0 ? true : false}
                  value={datasource.length > 0 ? selectedDataSource : ""}
                  onChange={handleDataSourceChange}
                  fullWidth
                  size="small"
                >
                  {datasource.length > 0
                    ? datasource.map((ds, index) => {
                        return (
                          <MenuItem
                            key={ds.dataSourceID}
                            value={ds.dataSourceName}
                          >
                            {ds.dataSourceName}
                          </MenuItem>
                        );
                      })
                    : null}
                </TextField>
              </Grid>

              <Grid item xs={6} sm={3} md={3.5} lg={4}>
                <TextField
                  variant="outlined"
                  label="Duration"
                  select={duration.length > 0 ? true : false}
                  value={duration.length > 0 ? selectedDurationName : ""}
                  onChange={handleDurationChange}
                  fullWidth
                  size="small"
                >
                  {duration.length > 0
                    ? duration.map((ds, index) => {
                        return (
                          <MenuItem key={ds.durationID} value={ds.durationName}>
                            {ds.durationName}
                          </MenuItem>
                        );
                      })
                    : null}
                </TextField>
              </Grid>
              <Grid item xs={0} sm={0} md={0} lg={0.1}></Grid>

              <Grid item xs={12} sm={6} md={1.2} lg={1}>
                <Box justifyContent="center" display="flex">
                  <Button
                    variant="contained"
                    onClick={handleDisplay}
                    size="large"
                  >
                    Search
                  </Button>
                </Box>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={1} lg={1}>
              {showOrHideExport && (
                <Box
                  sx={{
                    ml: "calc(100% - 80px)",
                    width: "180px",
                  }}
                >
                  <IconButton onClick={(e) => exportDataAsFile(false)}>
                    <GridOnIcon sx={{ color: "green.main" }} />
                  </IconButton>
                  <IconButton onClick={(e) => exportDataAsFile(true)}>
                    <PictureAsPdfIcon sx={{ color: "red.main" }} />
                  </IconButton>
                </Box>
              )}
            </Grid>
          </Box>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
          >
            <CircularProgress />
          </Backdrop>

          <Box mt={2} sx={{ width: "100%" }}>
            <DataGrid
              style={{ maxHeight: "calc(100vh - 130px)" }}
              disableColumnMenu
              sx={{
                "& .MuiDataGrid-columnHeaderTitle": {
                  whiteSpace: "normal",
                  lineHeight: "normal",
                },
                "& .MuiDataGrid-columnHeader": {
                  position: "sticky",
                },
                "& .MuiDataGrid-columnHeaders": {
                  // Forced to use important since overriding inline styles
                  maxHeight: "168px !important",
                },
              }}
              rows={getInDemandDataReport || []}
              columns={columns}
              getRowId={(row) => generateRandom()}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 20,
                  },
                },
              }}
              pageSizeOptions={[20, 50, 100]}
            />
          </Box>
        </Box>
      </CollapseSection>
    </div>
  );

  function generateRandom() {
    var length = 8,
      charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }
}
